export type AppRole = 'Installer' | 'Manager';

/**
 * Resolves the user's app role from the Azure AD `roles` claim.
 * Defaults to 'Manager' when no role is assigned, so existing users keep full
 * access until Installer roles are explicitly granted in Entra.
 *
 * SECURITY (#275): this Manager fail-open default is a UX affordance ONLY — it
 * gates which controls the client shows, never a real trust boundary. It MUST
 * NOT be ported to the Phase 3 server-side authorization (#239): the API must
 * deny-by-default (no/unknown role → least privilege), since a client role is
 * attacker-controllable and cannot be relied on for enforcement.
 */
export class AppRoleService {
  static resolveRole(roles: string[] | undefined): AppRole {
    if (roles?.includes('Installer') && !roles.includes('Manager')) return 'Installer';
    return 'Manager';
  }
}
